import { Button, getFontStyle } from '@diversioteam/diversio-ds'
import styled from 'styled-components'

import { SortableItem } from './../SortableItem'

export const FieldWrapper = styled.div`
    position: relative;
`

export const FieldContainer = styled.div`
    padding: 30px;
    display: flex;
    flex-direction: column;
    border-radius: 15px;
    background-color: ${({ theme }) => theme.colors.primaryWhite};
    box-shadow: 6px 12px 30px 0px rgba(0, 0, 0, 0.1);
    position: relative;
    overflow: hidden;

    &:before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 8px;
        background-color: ${({ theme }) => theme.colors.primary40};
    }

    .dds-input-button__placeholder {
        display: flex;
        gap: 4px;
    }

    .dds-single-select-option {
        justify-content: flex-start;
    }
`

export const DragIconWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
`

export const AddQuestionButton = styled(Button)`
    &.dds-button {
        width: 40px;
        height: 40px;
        position: absolute;
        top: 0;
        right: -12px;
        transform: translateX(100%);
        box-shadow: 6px 12px 30px 0px rgba(0, 0, 0, 0.1);
    }
`

export const QuestionRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 12px;

    .dds-single-select {
        white-space: nowrap;
    }
`

export const OptionList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;

    .MuiSvgIcon-root {
        margin-right: 6px;
        width: 20px;
        height: 20px;
        fill: ${({ theme }) => theme.colors.secondary300};
    }
`

export const OptionRow = styled.div`
    display: flex;
    align-items: center;
    position: relative;
`

export const SortableItemWrapper = styled(SortableItem)`
    position: relative;
`

export const OptionDragIcon = styled.div`
    display: none;
    position: absolute;
    left: -20px;
    bottom: 8px;
    cursor: grab;

    ${SortableItemWrapper}:hover & {
        display: block;
    }
`

export const AddOptionRow = styled(OptionRow)`
    .dds-text-field {
        width: 86px;
    }

    display: flex;
    align-items: center;

    span {
        display: inline-block;
        margin: 0 12px;
        color: ${({ theme }) => theme.colors.primary90};
    }
`

export const Footer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 24px;
    padding: 12px 0;
    border-top: 1px solid ${({ theme }) => theme.colors.primaryGray2};
`

export const SwitchWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 8px;
    padding-left: 8px;
    border-left: 1px solid ${({ theme }) => theme.colors.primaryGray2};
`

export const SwitchLabel = styled.label`
    color: ${({ theme }) => theme.colors.secondary500};

    ${getFontStyle('p02Medium')}
`
